export default __webpack_public_path__ + "static/media/mainPage.4f8d2d6f.jpg";